import { Box, Grid, HStack, Text, VStack, Tag, Wrap, WrapItem, Link, Divider } from '@chakra-ui/react';
import React from 'react';
import { MdOpenInNew } from 'react-icons/md';

const CampaignCard = ({ campaign }) => {
  const { code, channel, countries, createdAt, link } = campaign;

  return (
    <Box
      position={'relative'}
      maxW={'100%'}
      bg="backGround"
      borderRadius="12px"
      w={'52rem'}
      border="1px solid"
      borderColor="whiteAlpha.200"
      overflow="hidden"
      mb={4}
    >
      <VStack spacing={0} align="stretch">
        {/* Header Section */}
        <Box bg="whiteAlpha.50" px={6} py={4}>
          <HStack justify="space-between" align="center">
            <Text fontSize="lg" color="white" fontWeight="bold" letterSpacing="wide">
              {code}
            </Text>
            <HStack spacing={1}>
              <Text fontSize="xs" color="whiteAlpha.600" textTransform="uppercase">
                Created:
              </Text>
              <Text fontSize="sm" color="whiteAlpha.800" fontWeight="medium">
                {createdAt || '-'}
              </Text>
            </HStack>
          </HStack>
        </Box>

        <Divider borderColor="whiteAlpha.200" />

        {/* Content Section */}
        <Box px={6} py={5}>
          <Grid
            templateColumns={{ base: '1fr', md: '1fr 2fr' }}
            gap={6}
            alignItems="start"
          >
            {/* Channel */}
            <Box>
              <Text
                fontSize="xs"
                color="whiteAlpha.600"
                textTransform="uppercase"
                fontWeight="semibold"
                mb={2}
                letterSpacing="wider"
              >
                Channel
              </Text>
              <Text fontSize="md" color="white" fontWeight="medium">
                {channel || '-'}
              </Text>
            </Box>

            {/* Eligible Countries */}
            <Box>
              <Text
                fontSize="xs"
                color="whiteAlpha.600"
                textTransform="uppercase"
                fontWeight="semibold"
                mb={2}
                letterSpacing="wider"
              >
                Eligible Countries
              </Text>
              {countries?.length > 0 ? (
                <Wrap spacing={2}>
                  {countries.map((country) => (
                    <WrapItem key={country}>
                      <Tag
                        size="md"
                        colorScheme="brand"
                        variant="solid"
                        color="black"
                        fontWeight="semibold"
                        px={3}
                        borderRadius="full"
                      >
                        {country}
                      </Tag>
                    </WrapItem>
                  ))}
                </Wrap>
              ) : (
                <Text fontSize="md" color="whiteAlpha.700">-</Text>
              )}
            </Box>
          </Grid>
        </Box>

        {/* Footer Section - Campaign Link */}
        {link && (
          <>
            <Divider borderColor="whiteAlpha.200" />
            <Box px={6} py={3} bg="whiteAlpha.25">
              <Link
                href={link}
                isExternal
                color="brand.400"
                fontSize="sm"
                fontWeight="medium"
                _hover={{ color: 'brand.300', textDecoration: 'none' }}
                display="inline-flex"
                alignItems="center"
                gap={2}
              >
                <Text>View Campaign Link</Text>
                <MdOpenInNew size="14px" />
              </Link>
            </Box>
          </>
        )}
      </VStack>
    </Box>
  );
};

export default CampaignCard;
